import { PropertyItemCombinedProps } from './types';

const usePresenter = (props: PropertyItemCombinedProps): PropertyItemCombinedProps => {
  return props;
};

export default usePresenter;
